import { api } from "@/lib/api";

export const listExpenses = (params = {}) => {
    const q = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => v !== undefined && v !== null && v !== "" && q.set(k, v));
    return api.get(`/admin/expenses?${q}`).then((r) => r.data);
};
export const createExpense = (body) => api.post("/admin/expenses", body).then((r) => r.data);
export const updateExpense = (id, body) => api.patch(`/admin/expenses/${id}`, body).then((r) => r.data);
export const voidExpense = (id) => api.post(`/admin/expenses/${id}/void`).then((r) => r.data);
export const bulkImportExpenses = (rows) => api.post("/admin/expenses/bulk-import", { rows }).then((r) => r.data);

export const getPnl = (year, month) => api.get(`/admin/reports/pnl?year=${year}&month=${month}`).then((r) => r.data);
export const getPnlSummary = (months = 6) => api.get(`/admin/reports/pnl-summary?months=${months}`).then((r) => r.data);

export const aiChat = (message, conversation_id = null, context = null) =>
    api.post("/admin/ai/chat", { message, conversation_id, context }).then((r) => r.data);
export const aiMonthlySummary = (year, month, force_refresh = false) =>
    api.post(`/admin/ai/monthly-summary${force_refresh ? "?force_refresh=true" : ""}`, { year, month }).then((r) => r.data);
export const aiCashFlow = (months = 6, force_refresh = false) =>
    api.post(`/admin/ai/cash-flow-forecast${force_refresh ? "?force_refresh=true" : ""}`, { months }).then((r) => r.data);

export const EXPENSE_CATEGORIES = [
    { value: "SALARIES", label: "Salaries", emoji: "👥" },
    { value: "MARKETING", label: "Marketing", emoji: "📣" },
    { value: "OFFICE_RENT", label: "Office Rent", emoji: "🏢" },
    { value: "TRAVEL", label: "Travel", emoji: "✈️" },
    { value: "ADVERTISEMENTS", label: "Advertisements", emoji: "📺" },
    { value: "UTILITIES", label: "Utilities", emoji: "💡" },
    { value: "SOFTWARE_SUBSCRIPTIONS", label: "Software", emoji: "💻" },
    { value: "OTHER", label: "Other", emoji: "🧾" },
];

export const CATEGORY_LABEL = Object.fromEntries(EXPENSE_CATEGORIES.map((c) => [c.value, c.label]));

export const PAY_METHODS = ["CASH", "UPI", "BANK_TRANSFER", "CARD", "OTHER"];
export const EXPENSE_STATUSES = ["COMPLETED", "PENDING", "REIMBURSED", "VOID"];

export function todayIso() {
    return new Date().toISOString().slice(0, 10);
}

export function monthLabel(y, m) {
    return new Date(y, m - 1, 1).toLocaleDateString("en-IN", { month: "short", year: "numeric" });
}
